<!--
Author: Liubo
Date: 2018-09-17
Desc: 业务组件标题栏
 -->
<template>
    <div v-if="title" class="comp-bizcomp-title comp">
        <div class="title">
            {{ title }}
        </div>
        <div class="slot">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: "BizcompTitle",
    props: {
        title: {
            type: String,
            default: ""
        }
    },
    data() {
        return {};
    }
};
</script>
<style lang="scss">
.comp-bizcomp-title {
    border-bottom: 1px solid $border-color3;
    /* margin-bottom: 5px; */
    .title {
        font-size: 18px;
        line-height: 47px;
        color: var(--color-primary);
        padding-left: 18px;
        display: inline-block;
    }
    .slot {
        float: right;
        // 面包屑导航
        .el-breadcrumb {
            &:before {
                content: "当前位置：";
                float: left;
                color: $text-color3;
            }
            line-height: 47px;
            padding: 0 12px;
            .el-breadcrumb__separator[class*="icon"] {
                margin: 0;
            }
            .el-breadcrumb__inner {
                color: $text-color2;
                &.is-link {
                    color: $text-color3;
                    font-weight: normal;
                }
            }
        }
    }
}
</style>
